import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const BaseError = styled.div`
  color: red;
  font-weight: 500;
  margin-top: 10px;
  font-size: 16px;
  line-height: 16px;
  @media ${device.tablet} {
    font-size: 12px;
    line-height: 12px;
  }
`;
